export const gitCommit = '27b5b11f'
